import { useEffect } from 'react'

import { getSportsPage } from '@/actions/actions'
import { PageContent } from '@/components/PageContent/PageContent'
import useStore from '@/store/useStore'

export const SportsPage = () => {
  const { setPage } = useStore((state) => state.page)

  useEffect(() => {
    void getSportsPage()
    return () => {
      setPage(null)
    }
  }, [])

  return <PageContent />
}
